module.exports = __webpack_public_path__ + "img/test-payment-method.446a8ca.svg";